import colors from "./colors";

const components = {
  MuiCard: {
    styleOverrides: {
      root: {
        backgroundColor: colors.white,
      },
    },
  },
  MuiList: {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        justifyContent: "center",
      },
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: "32px !important",
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        display: "flex",
        justifyContent: "space-between",
        minWidth: "150px",
        fontWeight: "bold",
        color: "#333",
        fontSize: "15px",
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none",
      },
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        backgroundColor: colors.white,
      },
      paper: {
        backgroundColor: colors.white,
      },
    },
    defaultProps: {
      slotProps: {
        paper: {
          elevation: 6,
        },
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        backgroundColor: colors.white,
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        "&.Mui-disabled": {
          backgroundColor: colors.white,
        },
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      select: {
        backgroundColor: colors.white,
        color: colors.greys[500],
      },
    },
  },
};

export default components;
